import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import PersonIcon from '@mui/icons-material/Person';
import { blue } from '@mui/material/colors';
import request from '../../utils/request';
import loaderGif from '../common/no_bg_loader.gif';

export interface SimpleDialogProps {
  openBranchConf: boolean;
  closeBranchConfModal: (value: string) => void;
}

export default function ChangeBranch({ openBranchConf, closeBranchConfModal }) {
  const [loader, setLoader] = React.useState(false);
  const [userBranches, setUserBranches] = React.useState([]);

  React.useEffect(() => {
    if (openBranchConf) {
      getUserBranches();
    }
  }, [openBranchConf]);

  const userDatas = JSON.parse(localStorage.getItem('userDatas'));

  const getUserBranches = () => {
    setLoader(true);
    request({
      url: 'user/getUserBranchList',
      method: 'post'
    }).then(
      (response) => {
        setLoader(false);
        // setTotalCount(response['typeCount']);
        setUserBranches(response['userBranches']);
      },
      (error) => {
        setLoader(false);
        console.log(error);
      }
    );
  };

  const changeUserBranch = (branch_id) => {
    setLoader(true);
    request({
      url: 'auth/switchUserBranch',
      method: 'post',
      data: {
        branchId: branch_id
      }
    }).then(
      (response:any) => {
        localStorage.setItem('userDatas', JSON.stringify(response));
        localStorage.setItem('permissionDatas', JSON.stringify(response['userData']));

        let switch_admin_wdow = false;
        if ( response?.userData?.userType == 'Admin' && response?.userData?.activeBranchData?.userType == 'Admin'  ) {
          switch_admin_wdow = true;
        }
        window.location.href =  '/dashboards/dashboard?switch_admin_wdow=' + switch_admin_wdow;
      },
      (error) => {
        setLoader(false);
        console.log(error);
      }
    );
  };
  return (
    <Dialog onClose={closeBranchConfModal} open={openBranchConf}>
      <DialogTitle>Change Your Branch</DialogTitle>
      {loader ? (
        <div style={{ marginBottom: 10 }}>
          <img
            style={{ margin: '0 auto', display: 'block' }}
            alt="loader"
            src={loaderGif}
            className="loader"
            width={100}
            height={100}
          />
        </div>
      ) : (
        <List sx={{ pt: 0 }}>
          {userBranches.map((userBranch) => (
            <ListItem disableGutters>
              <ListItemButton
                onClick={() => changeUserBranch(userBranch.id)}
                key={userBranch.id}
                //   {userDatas.userData?.activeBranchId==userBranch?.userBranch?.id ?
                sx={{
                  backgroundColor:
                    userDatas.userData?.activeBranchId == userBranch?.id
                      ? `rgb(167 170 191)`
                      : ''
                }}
              >
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                    {userBranch?.userBranch?.branchName
                      .split('')[0]
                      .toUpperCase()}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    userBranch?.userBranch?.branchName +
                    ' (' +
                    userBranch?.userBranch?.branchCode +
                    ')-' +
                    userBranch?.role?.name
                  }
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      )}
    </Dialog>
  );
}
